import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class TutorProfileMenu extends Component {
    render() {
        return (<div className="col-md-3">
            <div className="step-box">
                <div className="list-group">
                    <NavLink to="/tutor/change-password" className="list-group-item list-group-item-action">
                    Change Password</NavLink>
                    <NavLink to="/tutor/profile-photo" className="list-group-item list-group-item-action">
                    Profile Photo</NavLink>
                    <NavLink to="/tutor/deactivate-account" className="list-group-item list-group-item-action">
                    Deactivate Account</NavLink>
                </div>
            </div>
        </div>);
    }
}

export default TutorProfileMenu;